module.exports = __webpack_public_path__ + "img/tela-faelflix.8f460f5e.png";